"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAgentInsightsStatsAgentInsightsAgentIdGetRequest$ = exports.GetAgentInsightsStatsAgentInsightsAgentIdGetRequest$outboundSchema = exports.GetAgentInsightsStatsAgentInsightsAgentIdGetRequest$inboundSchema = exports.GetAgentInsightsStatsAgentInsightsAgentIdGetSecurity$ = exports.GetAgentInsightsStatsAgentInsightsAgentIdGetSecurity$outboundSchema = exports.GetAgentInsightsStatsAgentInsightsAgentIdGetSecurity$inboundSchema = void 0;
exports.getAgentInsightsStatsAgentInsightsAgentIdGetSecurityToJSON = getAgentInsightsStatsAgentInsightsAgentIdGetSecurityToJSON;
exports.getAgentInsightsStatsAgentInsightsAgentIdGetSecurityFromJSON = getAgentInsightsStatsAgentInsightsAgentIdGetSecurityFromJSON;
exports.getAgentInsightsStatsAgentInsightsAgentIdGetRequestToJSON = getAgentInsightsStatsAgentInsightsAgentIdGetRequestToJSON;
exports.getAgentInsightsStatsAgentInsightsAgentIdGetRequestFromJSON = getAgentInsightsStatsAgentInsightsAgentIdGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const shared = __importStar(require("../shared/index.js"));
/** @internal */
exports.GetAgentInsightsStatsAgentInsightsAgentIdGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetAgentInsightsStatsAgentInsightsAgentIdGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetAgentInsightsStatsAgentInsightsAgentIdGetSecurity$;
(function (GetAgentInsightsStatsAgentInsightsAgentIdGetSecurity$) {
    /** @deprecated use `GetAgentInsightsStatsAgentInsightsAgentIdGetSecurity$inboundSchema` instead. */
    GetAgentInsightsStatsAgentInsightsAgentIdGetSecurity$.inboundSchema = exports.GetAgentInsightsStatsAgentInsightsAgentIdGetSecurity$inboundSchema;
    /** @deprecated use `GetAgentInsightsStatsAgentInsightsAgentIdGetSecurity$outboundSchema` instead. */
    GetAgentInsightsStatsAgentInsightsAgentIdGetSecurity$.outboundSchema = exports.GetAgentInsightsStatsAgentInsightsAgentIdGetSecurity$outboundSchema;
})(GetAgentInsightsStatsAgentInsightsAgentIdGetSecurity$ || (exports.GetAgentInsightsStatsAgentInsightsAgentIdGetSecurity$ = GetAgentInsightsStatsAgentInsightsAgentIdGetSecurity$ = {}));
function getAgentInsightsStatsAgentInsightsAgentIdGetSecurityToJSON(getAgentInsightsStatsAgentInsightsAgentIdGetSecurity) {
    return JSON.stringify(exports.GetAgentInsightsStatsAgentInsightsAgentIdGetSecurity$outboundSchema.parse(getAgentInsightsStatsAgentInsightsAgentIdGetSecurity));
}
function getAgentInsightsStatsAgentInsightsAgentIdGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetAgentInsightsStatsAgentInsightsAgentIdGetSecurity$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetAgentInsightsStatsAgentInsightsAgentIdGetSecurity' from JSON`);
}
/** @internal */
exports.GetAgentInsightsStatsAgentInsightsAgentIdGetRequest$inboundSchema = z.object({
    agent_id: z.string(),
    "filter[end_date]": z.string().optional(),
    "filter[listing_type]": shared.ListingType$inboundSchema.optional(),
    "filter[max_estimated_value]": z.number().int().optional(),
    "filter[max_estimated_value_rounded]": z.number().int().optional(),
    "filter[max_price]": z.number().int().optional(),
    "filter[min_estimated_value]": z.number().int().optional(),
    "filter[min_estimated_value_rounded]": z.number().int().optional(),
    "filter[min_price]": z.number().int().optional(),
    "filter[property_type]": z.array(shared.PropertyType$inboundSchema)
        .optional(),
    "filter[start_date]": z.string().optional(),
    outcode: z.array(z.string()).optional(),
    point: z.array(z.string()).optional(),
    postcode: z.string().optional(),
    radius: z.number().int().optional(),
    sector: z.array(z.string()).optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "agent_id": "agentId",
        "filter[end_date]": "filterEndDate",
        "filter[listing_type]": "filterListingType",
        "filter[max_estimated_value]": "filterMaxEstimatedValue",
        "filter[max_estimated_value_rounded]": "filterMaxEstimatedValueRounded",
        "filter[max_price]": "filterMaxPrice",
        "filter[min_estimated_value]": "filterMinEstimatedValue",
        "filter[min_estimated_value_rounded]": "filterMinEstimatedValueRounded",
        "filter[min_price]": "filterMinPrice",
        "filter[property_type]": "filterPropertyType",
        "filter[start_date]": "filterStartDate",
    });
});
/** @internal */
exports.GetAgentInsightsStatsAgentInsightsAgentIdGetRequest$outboundSchema = z.object({
    agentId: z.string(),
    filterEndDate: z.string().optional(),
    filterListingType: shared.ListingType$outboundSchema.optional(),
    filterMaxEstimatedValue: z.number().int().optional(),
    filterMaxEstimatedValueRounded: z.number().int().optional(),
    filterMaxPrice: z.number().int().optional(),
    filterMinEstimatedValue: z.number().int().optional(),
    filterMinEstimatedValueRounded: z.number().int().optional(),
    filterMinPrice: z.number().int().optional(),
    filterPropertyType: z.array(shared.PropertyType$outboundSchema).optional(),
    filterStartDate: z.string().optional(),
    outcode: z.array(z.string()).optional(),
    point: z.array(z.string()).optional(),
    postcode: z.string().optional(),
    radius: z.number().int().optional(),
    sector: z.array(z.string()).optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        agentId: "agent_id",
        filterEndDate: "filter[end_date]",
        filterListingType: "filter[listing_type]",
        filterMaxEstimatedValue: "filter[max_estimated_value]",
        filterMaxEstimatedValueRounded: "filter[max_estimated_value_rounded]",
        filterMaxPrice: "filter[max_price]",
        filterMinEstimatedValue: "filter[min_estimated_value]",
        filterMinEstimatedValueRounded: "filter[min_estimated_value_rounded]",
        filterMinPrice: "filter[min_price]",
        filterPropertyType: "filter[property_type]",
        filterStartDate: "filter[start_date]",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetAgentInsightsStatsAgentInsightsAgentIdGetRequest$;
(function (GetAgentInsightsStatsAgentInsightsAgentIdGetRequest$) {
    /** @deprecated use `GetAgentInsightsStatsAgentInsightsAgentIdGetRequest$inboundSchema` instead. */
    GetAgentInsightsStatsAgentInsightsAgentIdGetRequest$.inboundSchema = exports.GetAgentInsightsStatsAgentInsightsAgentIdGetRequest$inboundSchema;
    /** @deprecated use `GetAgentInsightsStatsAgentInsightsAgentIdGetRequest$outboundSchema` instead. */
    GetAgentInsightsStatsAgentInsightsAgentIdGetRequest$.outboundSchema = exports.GetAgentInsightsStatsAgentInsightsAgentIdGetRequest$outboundSchema;
})(GetAgentInsightsStatsAgentInsightsAgentIdGetRequest$ || (exports.GetAgentInsightsStatsAgentInsightsAgentIdGetRequest$ = GetAgentInsightsStatsAgentInsightsAgentIdGetRequest$ = {}));
function getAgentInsightsStatsAgentInsightsAgentIdGetRequestToJSON(getAgentInsightsStatsAgentInsightsAgentIdGetRequest) {
    return JSON.stringify(exports.GetAgentInsightsStatsAgentInsightsAgentIdGetRequest$outboundSchema.parse(getAgentInsightsStatsAgentInsightsAgentIdGetRequest));
}
function getAgentInsightsStatsAgentInsightsAgentIdGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetAgentInsightsStatsAgentInsightsAgentIdGetRequest$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetAgentInsightsStatsAgentInsightsAgentIdGetRequest' from JSON`);
}
//# sourceMappingURL=getagentinsightsstatsagentinsightsagentidget.js.map